module.exports = __webpack_public_path__ + "d6bbc00bcb60c8b62c3372a849cdaab8.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/logo_ags.png
// module id = 868
// module chunks = 0